<div class="flex flex-row justify-center items-center">
    <div class="public-container">
        @if (state === initState.INITIAL) {
          @if (hasError) {
            <pin-notification type="alert" class="w-full">
              This page is currently unavailable. Please try again later.
            </pin-notification>
          }
          <div class="flex flex-col gap-10">
              <form class="flex flex-col gap-4" [formGroup]="forgotUsernameForm" (ngSubmit)="retrieveUsername()">
                  <div class="flex flex-col gap-6">
                      <div class="flex flex-col gap-2">
                          <div class="dcp-h1">
                              Forgot Username
                          </div>
                          <p class="dcp-body">
                              Please enter your email address associated with your Depositor Control Panel account.
                          </p>
                      </div>
                      <mat-form-field class="w-full" appearance="outline">
                          <mat-label>Email Address</mat-label>
                          <input matInput placeholder="Email Address" type="text" formControlName="email" i18n-placeholder="@@email-placeholder" pinAutoFocus/>
                          @if (forgotUsernameForm.controls['email'].hasError('required')) {
                            <mat-error i18n="@@forgotUsername.email.required">
                                Email Address is <strong>required</strong>
                            </mat-error>
                          }
                          @if (forgotUsernameForm.controls['email'].hasError('email')) {
                            <mat-error i18n="@@forgotUsername.email.invalid">
                                Email Address is <strong>invalid</strong>
                            </mat-error>
                          }
                      </mat-form-field>
                  </div>
                   <div class="flex flex-col gap-6">
                        <pin-button buttonStyle="filled" buttonType="submit" buttonId="recover-username-button" [isDisabled]="processingRequest">RECOVER USERNAME</pin-button>
                       <div class="flex flex-row justify-center items-center">
                         <pin-button buttonStyle="icon-link" [buttonType]="buttonType.DEFAULT" iconName="arrow_back" buttonId="forgot-username-back-to-login-button" redirectUrl="/login">
                          Back to login
                      </pin-button>
                      </div>
                  </div>
              </form>
          </div>
        } @else {
            <div class="flex flex-col gap-10">
                <div class="flex flex-col gap-2">
                    <div class="flex flex-row gap-4">
                        <mat-icon class="md-37 primary-color">person_outline</mat-icon>
                        <div class="dcp-h2">Username Sent</div>
                    </div>
                    <p class="dcp-body">
                      If the information you provided is valid, you will receive an email shortly.
                    </p>
                </div>
                 <div class="flex flex-col gap-10">
                          <pin-button buttonStyle="filled" buttonId="forgot-username-return-to-login-button" redirectUrl="/login">RETURN TO LOGIN</pin-button>
                 </div>
            </div>
        }
    </div>
</div>
@if (processingRequest) {
  <div class="pin-spinner fullscreen">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
